import React from "react";
import styled from "styled-components";
import FillBar from "../../../../components/metrics/FillBar";
import utilsService from "../../../../../servises/utils.service";
import TotalVerticalInfo from "../../../../components/metrics/TotalVerticalInfo";
import { EuiIcon } from "@elastic/eui";

const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 4px 0;
`;

const StorageSection = styled.div`
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.04);
  border-radius: 8px;
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  
  .header-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    
    .label-group {
      display: flex;
      align-items: center;
      gap: 6px;
      font-size: 11px;
      color: rgba(255, 255, 255, 0.45);
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      
      .icon {
        color: ${props => props.color || 'rgb(0, 128, 213)'};
        opacity: 0.8;
      }
    }
    
    .value-pct {
      font-size: 14px;
      font-weight: 800;
      color: #fff;
      font-family: Consolas, monospace;
    }
  }
  
  .details-bar {
    margin: 4px 0;
    
    & > div {
      margin: 0;
    }
  }
`;

const DisksListStyled = styled.section`
  display: flex;
  gap: 12px;
  overflow-x: auto;
  padding: 8px 4px;
  margin-top: 6px;
  
  &::-webkit-scrollbar {
    height: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 3px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
`;

function generateDisks(server) {
    let disks = [];

    if (server && server.metrics && server.metrics[0]) {
        const metrics = server.metrics[0];
        const disksList = metrics.disk_list;

        if (disksList && disksList.length > 0) {
            disks = disksList.map(pd => {
                const total = utilsService.formatBytes(pd.total);
                const used = utilsService.formatBytes(pd.used);

                return ({
                    name: pd.name,
                    total: pd.total,
                    totalData: total.value,
                    totalUnit: total.unit,
                    used: pd.used,
                    usedData: used.value,
                    usedUnit: used.unit
                });
            });
        }
    }

    disks.sort((a, b) => b.total - a.total);

    return disks;
}

const ServerDisksWidget = ({ server }) => {
    const diskTotal = utilsService.getFromMetrics(server, "disk_total");
    const diskUsage = utilsService.getFromMetrics(server, "disk_usage");

    const swapTotal = utilsService.getFromMetrics(server, "swap_total");
    const swapUsage = utilsService.getFromMetrics(server, "swap_usage");

    const disksData = generateDisks(server);

    const diskPct = utilsService.getPercent(diskUsage, diskTotal) || 0;
    const swapPct = utilsService.getPercent(swapUsage, swapTotal) || 0;

    return (
        <CardWrapper>
            {/* Total Storage */}
            <StorageSection color="#ed8936">
                <div className="header-row">
                    <div className="label-group">
                        <EuiIcon type="storage" size="s" className="icon" />
                        <span>Total Storage</span>
                    </div>
                    <span className="value-pct">{ diskPct }%</span>
                </div>
                <div className="details-bar">
                    <FillBar
                        total={ server.serverData.diskDataTotal.value }
                        totalUnit={ server.serverData.diskDataTotal.unit }
                        current={ server.serverData.diskDataCurrent.value }
                        currentUnit={ server.serverData.diskDataCurrent.unit }
                        originalTotal={ diskTotal }
                        originalCurrent={ diskUsage }
                    />
                </div>
            </StorageSection>

            {/* Swap Space */}
            <StorageSection color="#f9be49">
                <div className="header-row">
                    <div className="label-group">
                        <EuiIcon type="storage" size="s" className="icon" />
                        <span>Swap Space</span>
                    </div>
                    <span className="value-pct">{ swapPct }%</span>
                </div>
                <div className="details-bar">
                    <FillBar
                        total={ server.serverData.swapDataTotal.value }
                        totalUnit={ server.serverData.swapDataTotal.unit }
                        current={ server.serverData.swapDataCurrent.value }
                        currentUnit={ server.serverData.swapDataCurrent.unit }
                        originalTotal={ swapTotal }
                        originalCurrent={ swapUsage }
                    />
                </div>
            </StorageSection>

            {/* Partition Slots */}
            { disksData.length > 0 && (
                <div style={ { marginTop: '4px' } }>
                    <div style={ { fontSize: '10px', color: 'rgba(255,255,255,0.4)', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.5px', padding: '0 4px', marginBottom: '6px' } }>
                        Partition Drives ({ disksData.length })
                    </div>
                    <DisksListStyled>
                        { disksData.map((item, idx) => {
                            if (item.name) {
                                return (
                                    <TotalVerticalInfo
                                        key={ idx + "d21dz" }
                                        title={ item.name }
                                        start={ 0 }
                                        current={ item.usedData }
                                        total={ item.totalData }
                                        currentOriginal={ item.used }
                                        totalOriginal={ item.total }
                                        totaExt={ item.totalUnit }
                                        currentExt={ item.usedUnit }
                                    />
                                );
                            } else {
                                return null;
                            }
                        }) }
                    </DisksListStyled>
                </div>
            ) }

        </CardWrapper>
    );
};

export default ServerDisksWidget;
